import {
  assign,
  each,
  isArray,
  isEmpty,
  merge,
  omit,
  reduce,
  map,
  valuesIn,
  has,
  toLower,
  sumBy,
  toNumber,
  toString,
} from 'lodash';
import types from './mutationTypes';

const sumBetslipBets = (payload) => {
  const totalPayment = sumBy(payload, item => toNumber(item.payment)).toFixed(2);
  return toNumber(totalPayment);
};

const calculateMaxWinnings = (bets) => {
  const maxWinnings = reduce(bets, (sum, bet) => {
    const add = bet.payment + (bet.payment * bet.odds);
    return sum + add;
  }, 0);

  return maxWinnings;
};

const distributeTotalPayment = (bets, payment, payin) => {
  const paymentPerBet = payment / bets.length;

  each(bets, (bet) => {
    assign(bet, {
      payment: bet.payment || paymentPerBet,
    });
  });

  return {
    payment,
    payin,
    bets,
    winnings: {
      min: 0,
      max: calculateMaxWinnings(bets),
    },
  };
};

const updateBets = (bets) => {
  const ticketBets = each(bets, (bet) => {
    // eslint-disable-next-line
    bet.event += 1;
  });

  return ticketBets;
};

const setBetShortcuts = (data) => {
  const allShortcuts = [];
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Collator
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  each(valuesIn(data), (bet) => {
    if (bet.shortcut) {
      if (bet.shortcut.name.indexOf('x') > -1) {
        if (bet.shortcut.name === 'Tx') {
          each(bet.shortcut.params, (value, index) => {
            allShortcuts.push(bet.shortcut.name.split('x').join(bet.shortcut.params[index]));
          });
        } else if (bet.shortcut.name === 'xSy') {
          each(bet.values, (value) => {
            if (value[0] === -1) {
              const x = bet.shortcut.name.split('x').join('00');
              allShortcuts.push(x.split('y').join(value[1]));
              const y = bet.shortcut.name.split('x').join(value[1]);
              allShortcuts.push(y.split('y').join('00'));
            } else {
              const x = bet.shortcut.name.split('x').join(value[0]);
              allShortcuts.push(x.split('y').join(value[1]));
              const y = bet.shortcut.name.split('x').join(value[1]);
              allShortcuts.push(y.split('y').join(value[0]));
            }
          });
        } else {
          each(bet.values, (value) => {
            allShortcuts.push(bet.shortcut.name.split('x').join(value[bet.shortcut.paramsValueIndex]));
          });
        }
      } else {
        allShortcuts.push(bet.shortcut.name);
      }
    }
  });
  const shortcuts = allShortcuts.sort(collator.compare);
  return shortcuts;
};

const setLimits = (payload) => {
  let limits = {};
  const wheelTickets = payload.wheel.definition.tickets;
  if (has(wheelTickets, 'ticketPaymentLimitsPerChannel')) {
    const channel = payload.channel !== 'shop' ? payload.channel : 'retail';
    const channelLimits = wheelTickets.ticketPaymentLimitsPerChannel[toLower(channel)];
    limits = {
      ticket: {
        ticketMinPayment: channelLimits.ticket.min,
        ticketMaxPayment: channelLimits.ticket.max,
      },
      bet: {
        ticketBetMinPayment: channelLimits.bet.min,
        ticketBetMaxPayment: channelLimits.bet.max,
      },
    };
  } else {
    limits = {
      ticket: {
        ticketMinPayment: wheelTickets.ticketMinPayment,
        ticketMaxPayment: wheelTickets.ticketMaxPayment,
      },
      bet: {
        ticketBetMinPayment: wheelTickets.ticketBetMinPayment,
        ticketBetMaxPayment: wheelTickets.ticketBetMaxPayment,
      },
    };
  }
  return limits;
};

export default {
  [types.ADD_TICKET_BET](state, bet) {
    const { bets } = state.ticket;

    if (isArray(bet)) {
      bets.push(...bet);
    } else {
      bets.push(bet);
    }

    assign(state.ticket, {
      bets,
      payment: sumBetslipBets(bets),
      winnings: {
        min: 0,
        max: calculateMaxWinnings(bets),
      },
    });
  },
  [types.CLEAR_TICKET](state) {
    state.ticket = {
      bets: [],
      payment: 0,
      winnings: {
        min: 0,
        max: 0,
      },
    };
  },
  [types.SET_AUTH](state, auth) {
    state.auth = auth;
  },
  [types.SET_CONFIG](state, config) {
    assign(state.config, omit(config, ['round', 'translations']));
    state.round = config.round;

    if (!isEmpty(config.translations)) {
      state.translations = merge({}, state.translations, config.translations);
    }
  },
  [types.SET_PLATFORM](state, platform) {
    state.platform = platform;
  },
  [types.SET_ROUND](state, round) {
    state.round = round;
  },
  [types.SET_NEXT_ROUNDS](state, nextRounds) {
    state.nextRounds = nextRounds;
  },
  [types.SET_USER](state, payload) {
    state.user = payload.user;
  },
  [types.SET_ALLOWED_SHORTCUT](state, data) {
    state.allowedShortcutChars.push(...map(data, toString));
  },
  [types.SET_SHORTCUTS](state, data) {
    const shortcuts = setBetShortcuts(data);
    state.betShortcuts = shortcuts;
  },
  [types.SET_LIMITS](state, payload) {
    state.limits = setLimits(payload);
  },
  [types.UPDATE_TICKET](state, ticket) {
    const calculatedTicket = distributeTotalPayment(ticket.bets, ticket.payment, ticket.payin);
    assign(state.ticket, calculatedTicket);
  },
  [types.UPDATE_TICKET_BETS](state, ticket) {
    const updatedBets = updateBets(ticket.bets);
    state.ticket.bets = updatedBets;
  },
  [types.UPDATE_BET](state, status) {
    state.updateBet = status;
  },
  [types.UPDATE_BETSLIP_BET](state, payload) {
    state.ticket = payload;
  },
};
